import { scale as initialScale } from '@components/frame';
import type { ScaleFunction } from '@components/operatorPanel/interfaces';

export const BATCH_PAGE_SIZE = 100;
export const FINISH_JOB_FEATURE_FLAG = 'general-finish-job';
export const MAX_QUANTITY = 999999;
export const MAX_TIME_SECONDS = 999 * 3600; // 999 hours
export const MAX_NOTE_LENGTH = 2000;
export const OVERPRODUCTION_MULTIPLIER = 10;
export const TIME_OVERRUN_MULTIPLIER = 2;
export const PAST_DATE_WARNING_DAYS = 30;

// Job thumbnail box (raw px, scaled at use site) — shared by the JobInfoSection container
// width and the image props builder so the box and the image stay the same size.
export const FINISH_JOB_THUMBNAIL_WIDTH = 146;
export const FINISH_JOB_THUMBNAIL_HEIGHT = 97;

export const getStatusBadgeScale = (scale: ScaleFunction = initialScale): ScaleFunction => {
  // Scale function that produces 21px badge height
  const ratio = 21 / 23; // default badge height is scale(23), we want 21
  return (value, shouldRound) => scale(value * ratio, shouldRound);
};

// Error codes emitted by the SignalR `OnFailedToCloseProductionOperation` event.
// Contract: https://dev.azure.com/mysmartfactory/Backend/_wiki/wikis/Smart%20Factory/809/Finish-Job
export const CLOSE_PRODUCTION_OPERATION_ERROR_CODES = {
  JOB_ALREADY_FINISHED: 'JobAlreadyFinished',
  END_DATE_BEFORE_JOB_START_DATE: 'EndDateBeforeJobStartDate',
  TIME_OUTSIDE_VALID_TIME_RANGE: 'TimeOutsideValidTimeRange',
  QUANTITY_OUTSIDE_VALID_QUANTITY_RANGE: 'QuantityOutsideValidQuantityRange',
  NOTES_HAS_TOO_MANY_CHARACTERS: 'NotesHasTooManyCharacters',
} as const;

// Shown when finishing a job that runs on an active batch — the BE keeps it Running until the batch
// is finished (Job-Status-Determination wiki). Raw strings; AlertComponent translates at render.
export const FINISH_ON_ACTIVE_BATCH_ALERT = {
  title: 'Job is still running',
  text: 'This job runs on an active batch, so it stays Running until the batch is finished — then it completes automatically.',
};
